module.exports = __webpack_public_path__ + "static/media/plp_dropdown_icon.9a6a2866.svg";